import { FieldValues, useFormContext } from 'react-hook-form';
import { InputText, InputTextProps } from '../../forms/input-text/InputText';
import { forwardRef } from 'react';
import { getNestedErrorForm } from './form.utils';

interface ControllerInputTextCleanerProps extends InputTextProps {
	name: string;
	label: string;
	regexCleaner?: RegExp;
	information?: string;
	labelStyles?: string;
}

const cleanCharactersByRegex = (value: string, regex: RegExp): string => {
	if (!value) return value;
	return regex.test(value) ? value : value.slice(0, -1);
};

export const InputTextCleaner = forwardRef<HTMLInputElement, ControllerInputTextCleanerProps>(function InputTextCleaner(
	{ name, regexCleaner, labelStyles, ...props },
	ref
) {
	const {
		setValue,
		formState: { errors, isSubmitted }
	} = useFormContext<FieldValues>();

	return (
		<InputText
			ref={ref}
			{...props}
			name={name}
			errorMessage={getNestedErrorForm(errors, name)?.message}
			labelStyles={labelStyles}
			onChange={(e) => {
				let newValue = e.target.value;
				if (regexCleaner) {
					newValue = cleanCharactersByRegex(newValue, regexCleaner);
					setValue(name, newValue, {
						shouldDirty: isSubmitted,
						shouldValidate: isSubmitted
					});
				}
			}}
		/>
	);
});
